export default ({
  item_id = null,
  item_name = null,
  item_properties = null,
  remaining_qty = null,
  item_category = '',
  reasonPath = [],
  repairImageUrl = '',
}) => ({
  itemId: item_id,
  itemName: item_name,
  itemProperties: item_properties,
  itemQuantity: remaining_qty,
  itemCategory: item_category,
  repairImageUrl,
  reasonPath,
  lastEnabledSection: null,
  repair_reason_code_ids: null,
});
